import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { consoleDev, ConsoleStatus, fetchData } from '@quizzach/utils';

export const useActivateAccount = () => {
	const { pathname } = useLocation();
	const activationCode = pathname.split('/')[4];
	const userId = pathname.split('/')[3];

	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<boolean>(false);

	const activateAccount = async () => {
		setLoading(true);
		try {
			const response = await fetchData<any>(
				`/api/user/activate/${userId}/${activationCode}`,
				{ method: 'POST', body: JSON.stringify({}) }
			);
			if (response.status >= 300) {
				consoleDev('activateAccount', ConsoleStatus.HTTP, response.status);
				setError(true);
			} else {
				consoleDev('activateAccount', ConsoleStatus.SUCC);
			}
		} catch (err) {
			consoleDev('activateAccount', ConsoleStatus.NET, err);
			setError(true);
		} finally {
			setLoading(false);
		}
	};

	return { loading, error, activateAccount };
};
